import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { catchError } from '../../../core/catch-error';

import type { Member } from '../../../app/entities';

type ModalProps = {
  member: Member;
  onCancel: () => void;
};

export const RemoveMemberModal: React.FC<ModalProps> = ({ onCancel, member }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      await member.delete();
    } catch (error) {
      catchError(error);
    } finally {
      setIsLoading(false);
      onCancel();
    }
  };

  return (
    <Dialog
      title={`Are you sure you want to remove "${member.fullName}"`}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          variant="danger"
          text="Yes, remove access"
          type="submit"
          onClick={handleSubmit}
          key="delete-submit-button"
          isLoading={isLoading}
          autoFocus
        />,
      ]}
    >
      <InformationText>
        They won&apos;t be able to access your creative space anymore.
      </InformationText>
    </Dialog>
  );
};

const InformationText = styled.span`
  font-style: normal;
  font-size: 1.4rem;
  line-height: 1.9rem;
  color: #959bab;
`;
